import { Dialog } from "primereact/dialog"
import { useEffect, useState } from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useForm } from "react-hook-form"
import { JVInput } from "../../shared/JVInput"
import { Button } from "primereact/button"
import { Fetch } from "../../shared/Fetch"
import { Dropdown } from "primereact/dropdown"
import { FileUpload } from "primereact/fileupload"
import { Tag } from "primereact/tag"
import { JVSunEditor } from "../../shared/JVSuneditor"

interface IProps {
    tableData: any[],
    openSendEmail: boolean,
    closeSendEmailModal: () => void,
    toast: any
}

interface ISendEmailForPaymentUpdate {
    senderEmail?: string | null;
    subject?: string | null;
    body?: string | null;
}

const schema = yup.object({
    subject: yup.string().nullable(),
    body: yup.string().nullable(),
});

export const MassMailing = (props: IProps) => {
    const [emailTemplatesData, setEmailTemplatesData] = useState<Array<any>>([])
    const [etId, setEtId] = useState<number | null>(null)
    const [body, setBody] = useState("")
    const [loading, setLoading] = useState(false)
    const [attachments, setAttachments] = useState<File[]>([])

    const { control, handleSubmit, formState: { errors }, reset, setValue } =
        useForm<ISendEmailForPaymentUpdate>({
            resolver: yupResolver(schema),
            defaultValues: {},
            shouldFocusError: false
        });

    const onSubmit = async (fbody: ISendEmailForPaymentUpdate) => {
        if (body.length < 1) {
            props.toast.current.show({ severity: 'error', detail: "Choose Template First.", life: 3000 });
            return;
        }
        setLoading(true);
        const formData = new FormData();
        formData.append("subject", fbody.subject || "");
        formData.append("body", body);
        formData.append("ids", JSON.stringify(props.tableData.map(item => item.id)));

        attachments.forEach((file) => {
            formData.append("attachments", file);
        });

        const response = await Fetch("Email_Template/sendMassMailing", "POST", formData, null, props.toast);

        if (response) {
            props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Email sent successfully!', life: 3000 });
            onHide();
        }
        setLoading(false);
    };

    const onClear = () => {
        reset();
        setLoading(false);
        setValue("subject", null);
        setValue("body", null);
        setEtId(null);
        setBody("");
        setAttachments([]);
    };

    const onHide = () => {
        onClear();
        setLoading(false);
        props.closeSendEmailModal();
    };

    useEffect(() => {
        if (props.openSendEmail) {
            loadEmailTemplates();
        }
    }, [props.openSendEmail]);

    const loadEmailTemplates = async () => {
        const response = await Fetch("Email_Template/emailTemplate", "GET", null, null, null);
        if (response) {
            const data: any = await response.json();
            setEmailTemplatesData(data);
        }
    };

    useEffect(() => {
        if (etId) {
            loadTemplateDetails(etId);
        }
    }, [etId]);

    const loadTemplateDetails = async (id: number) => {
        const response = await Fetch(`Email_Template/emailTemplate/${id}`, "GET", null, null, null);
        if (response) {
            const data: any = await response.json();
            setValue("subject", data.template_Subject || "");
            setBody(data.template_Body || "");
        }
    };

    const onSelectFiles = (e: any) => {
        setAttachments(prev => [...prev, ...e.files]);
    };

    const onRemoveFile = (e: any) => {
        setAttachments(prev => prev.filter(f => f.name !== e.file.name));
    };


    return (
        <Dialog style={{ width: '70vw' }} visible={props.openSendEmail} onHide={onHide} header="Mass Mailing">
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {/* Recipients */}
                <div className="col-12 md:col-12 mb-3">
                    <label>Recipients</label>
                    <div className="flex flex-wrap gap-2 mt-2">
                        {props.tableData.map((item, index) => (
                            <Tag key={index} value={item.name} rounded severity="info" />
                        ))}
                    </div>
                </div>
                {/* Template Dropdown */}
                <div className="field col-12 md:col-6">
                    <Dropdown options={emailTemplatesData} optionValue="template_Id" optionLabel="template_Name" value={etId} onChange={e => setEtId(e.value)} placeholder="Choose Email Template" />
                </div>
                {/* Subject */}
                <JVInput column={1} label="Subject" control={control} name="subject" error={errors.subject?.message} />
                {/* Body */}
                <div className="col-12 md:col-12 mb-3">
                    <label>Body</label>
                    <JVSunEditor name="body" value={body} handleChange={setBody} />
                </div>

                {/* Attachments */}
                <div className="col-12 md:col-12 mb-3">
                    <label>Attachments</label>
                    <FileUpload name="attachments[]" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif" customUpload uploadHandler={() => { }} onSelect={onSelectFiles} onRemove={onRemoveFile} onClear={() => setAttachments([])} />
                    {attachments.length > 0 && (
                        <ul className="mt-2">
                            {attachments.map((file, i) => (
                                <li key={i}>{file.name}</li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Buttons */}
                <div className="col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} label="SEND" type={loading === false ? "submit" : "button"} style={{ width: '100px' }} />
                    <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={onClear} type="button" />
                </div>
            </form>
        </Dialog>
    )
}
